// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';
import Treatment from './Treatment'

export default class OrderDetailed {
    constructor(args) {
		args = toCamelCaseProperties(args) || {};
        this.appointmentDate = args.appointmentDate || ''
        this.appointmentEmployeeId = args.appointmentEmployeeId || ''
        this.appointmentId = args.appointmentId || ''
        this.base64AppointmentId = args.base64AppointmentId || ''
        this.cancellationHours = args.cancellationHours || ''
        this.conditions = args.conditions || ''
        this.donations = args.donations || []
        this.endTimeTreatments = args.endTimeTreatments || ''
        this.products = args.fixitNoProducts || []
        this.orderDate = args.orderDate || ''
        this.orderHistoryType = setAppointmentType(args.orderHistoryType || null)
        this.receiptId = args.receiptId || null
        this.siteId = args.siteId || 0
        this.fixitSiteId = args.fixitSiteId || ''
        this.siteName = args.siteName || ''
        this.startTimeTreatments = args.startTimeTreatments || ''
        this.totalPrice = args.totalPrice || 0
        this.departmentRatingId = args.departmentRatingId || null
        this.treatments = args.treatments.map(x => new Treatment(x)) || []
        this.urlSafeSiteName = args.urlSafeSiteName || ''
        this.fairPayStatus = setFairPayStatus(args.fairPayStatus || 0)
        this.actualFee = args.actualFee || null
        this.fairPayCancellationHours = args.fairPayCancellationHours || null
        this.paymentMethod = setPaymentMethod(args.paymentMethodId) || null
        this.salonInformation = args.salonInformation || null
        this.updatedTime = args.updatedTime || null
        this.fairPayEnabled = args.fairPayEnabled || false
        this.fairPayNoShowFeeGraceHours = args.fairPayNoShowFeeGraceHours || null
        this.fairPayType = setFairPayType(args.fairPayType) || null
	}

	assign(order) {
		Object.assign(this, toCamelCaseProperties(order));
	}
}

function setFairPayStatus(fairPayStatus) {
    switch (fairPayStatus) {
        case 0: return 'UNKNOWN'; 
        case 1: return 'NEW'
        case 2: return 'REMINDER1'
        case 3: return 'REMINDER2'
        case 4: return 'PARDONED'
        case 5: return 'PAID'
        case 6: return 'FEE_SENT'
    }
}

function setFairPayType(fairPayType) {
    switch (fairPayType) {
        case 0: return 'UNKNOWN'; 
        case 1: return 'CANCELLATION'
        case 2: return 'DELETED_AT_SITE'
        case 3: return 'FAIRPAY'
        case 4: return 'MOVE_APPOINTMENT'
    }
}

function setAppointmentType(orderHistoryType) {
    switch (orderHistoryType) {
        case 0: return ''
        case 1: return 'future-visit'
        case 2: return 'previous-visit'
        case 3: return 'cancelled' //timebokbesokstatus 4
        case 4: return 'noshow'//timebokbesokstatus 5
    }
}

function setPaymentMethod(paymentMethodId) {
    switch (paymentMethodId) {
        case 0: return 'Kort'
        case 1: return 'Vipps'
        case 5: return 'Klarna'
        case 6: return 'Apple Pay'
        case 7: return 'Google Pay'
        case 100: null //UNKNOWN
    }
}
